export const easeIn = 'cubic-bezier(1.00,0.00,0.78,1.00)';
export const easeOut = 'cubic-bezier(0.33,0.00,0.00,1.00)';
export const easeEasy = 'cubic-bezier(0.33,0.00,0.67,1.00)';
export const shotgun = 'cubic-bezier(0.00,0.00,0.00,1.00)';
export const easeIn90 = 'cubic-bezier(0.90,0.00,0.78,1.00)';
export const easeOut90 = 'cubic-bezier(0.33,0.00,0.10,1.00)';
export const easeIn80 = 'cubic-bezier(0.80,0.00,0.78,1.0)';
export const easeOut80 = 'cubic-bezier(0.33,0.00,0.20,1.00)';
export const easeIn70 = 'cubic-bezier(0.70,0.00,0.78,1.00)';
export const easeOut70 = 'cubic-bezier(0.33,0.00,0.30,1.00)';
export const easeIn60 = 'cubic-bezier(0.60,0.00,0.78,1.00)';
export const easeOut60 = 'cubic-bezier(0.33,0.00,0.40,1.00)';
export const easeInAlt = 'cubic-bezier(1.00,0.00,0.67,1.00)';
export const easeInSmooth = 'cubic-bezier(0.60,0.00,0.67,1.00)';
export const easeOutSmooth = 'cubic-bezier(0.60,0.00,0.00,1.00)';
export const expoIn5 = 'cubic-bezier(0.67,0.01,0.83,0.21)';
export const expoOut5 = 'cubic-bezier(0.17,0.8,0.33,0.99)';
export const expoInOut5 = 'cubic-bezier(0.78,0,0.22,1)';
export const bounce1 = 'cubic-bezier(0.65, 0.00, 0.26, 1.31)';
export const bounce2 = 'cubic-bezier(1.00, 0.00, 0.35, 1.36)';
